import { useSelector } from "react-redux";

import {
  selectFormattedFileImportsThroughPage,
  selectFormattedPaginatedFileImports,
  selectFileImportActivityTotal,
} from "./selectors";

export const useFormattedPaginatedFileImports = (pageNumber: number) => {
  return useSelector((state) =>
    selectFormattedPaginatedFileImports(state, pageNumber),
  );
};

export const useFormattedFileImportsThroughPage = (pageNumber: number) => {
  return useSelector((state) =>
    selectFormattedFileImportsThroughPage(state, pageNumber),
  );
};

export const useFileImportsTotalCount = () => {
  return useSelector(selectFileImportActivityTotal);
};
